import { AxiosRequestConfig } from "axios";
import * as moment from "moment";
import { Signal } from "signals";
import { MenuSection } from "slotworks/components/betbar/menus/menu-section";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiSprite from "slotworks/graphics/elements/flexi-sprite";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import Translations from "slotworks/i18n/translations";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import CommsManager from "slotworks/server/comms-manager";

export default class HistorySection extends MenuSection {

    private readonly moreButton: FlexiButton;
    private readonly loadingText: FlexiText;
    private readonly table: FlexiSprite;

    constructor(signal: Signal, initialValues: object, layer: Layers = Layers.MenusContent) {
        super(signal, initialValues, layer);

        this.loadingText = this.layer.getFlexiText("loading");
        this.table = this.layer.getFlexiSprite("historyTable");
        this.moreButton = this.layer.getFlexiButton("history_more");
        if (this.moreButton) {
            this.moreButton.on(ButtonEvent.POINTER_UP, this.moreHistory);
        }

        this.requestHistory();
    }

    public destroy() {
        if (this.moreButton) {
            this.moreButton.off(ButtonEvent.POINTER_UP, this.moreHistory);
        }

        super.destroy();
    }

    private populateHistory = (response: any) => {
        if (this.table) {
            this.table.setVisible(true);
        }

        let row = 1;
        let dateText = this.layer.getFlexiText("date_" + row);

        const transactions = response && response.data && response.data.TRANSACTIONS;

        if (this.loadingText) {
            if (transactions && !transactions.length) {
                this.loadingText.setText(Translations.get("gen.nod"));
                if (this.table) {
                    this.table.setVisible(false);
                }
                return;
            } else {
                this.loadingText.setVisible(false);
            }
        }

        while (dateText) {
            const timeText = this.layer.getFlexiText("time_" + row);
            const betText = this.layer.getFlexiText("bet_" + row);
            const winText = this.layer.getFlexiText("win_" + row);
            const pfsTag = this.layer.getFlexiSprite("pfs_" + row);

            let rowData;

            if (transactions) {
                if (transactions.length >= row) {
                    rowData = transactions[row - 1];
                }
            }

            if (!rowData) {
                break;
            }

            moment.locale();
            dateText.setText(moment(rowData.date).format("DD-MM-YYYY"));
            timeText.setText(moment(rowData.date).format("HH:mm:ss"));
            betText.setText(Currency.format(rowData.bet_amount));
            winText.setText(Currency.format(rowData.win_amount));

            if (pfsTag) {
                pfsTag.setAlpha(rowData.is_pfs === 1 ? 1 : 0);
            }

            row++;
            dateText = this.layer.getFlexiText("date_" + row);
        }
    }

    private requestHistory() {
        if (this.table) {
            this.table.setVisible(false);
        }

        if (this.loadingText) {
            this.loadingText.setVisible(true);
            this.loadingText.setText(Translations.get("gen.loa"));
        }

        // TODO: This only works for revolver, this whole system needs re-factoring / re-thinking for other systems
        const historyRequest = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify({
                cmd: "TRANSACTIONS",
                session: RevolverModel.session
            })
        } as AxiosRequestConfig;

        if (RevolverModel.jwt_token) {
            historyRequest.headers = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            };
        }

        CommsManager.requestRaw(historyRequest).then(this.populateHistory);
    }

    private moreHistory = () => {
        // TODO: Decouple revolver specific code
        window.open(SettingsModel.historyURL + RevolverModel.session + "?lang=" + SettingsModel.language);
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/components/betbar/menus/history-section.ts